import { useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { Copy } from '../../copy/Copy';
import { marginTop16Sx, buttonSx } from '../../styles/Global.style';
import { Form } from '../Form/Form';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import {
  CONTACT_INIT_VALUES,
  INTEREST_SELECT_OPTIONS,
  PVG_SELECT_OPTIONS,
} from '../../constants/contact';
import { CONTACT_VALIDATION_SCHEMA } from '../../validation/contact';
import emailjs from '@emailjs/browser';
import { FormSelect } from '../FormSelect/FormSelect';

export const ContactUsForm = ({ handleSubmit }) => {
  const theme = useTheme();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: CONTACT_INIT_VALUES,
    validationSchema: CONTACT_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await emailjs.send(
          process.env.REACT_APP_EMAIL_SERVICE_ID,
          process.env.REACT_APP_VOLUNTEER_TEMPLATE_ID,
          val,
          process.env.REACT_APP_EMAIL_PUBLIC_KEY,
        );

        handleSubmit();
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  return (
    <FormContainer
      className="animate__animated animate__fadeInRight"
      title={Copy.generate('ContactUsForm.title')}
    >
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="name"
          formik={formik}
          labelText={Copy.generate('Inputs.name')}
          required
        />
        <FormInput
          inputFor="email"
          formik={formik}
          labelText={Copy.generate('Inputs.email')}
          required
        />
        <FormInput
          inputFor="phone"
          formik={formik}
          labelText={Copy.generate('Inputs.contactNumber')}
          required
        />
        <FormSelect
          selectFor="interest"
          formik={formik}
          options={INTEREST_SELECT_OPTIONS}
          labelText={Copy.generate('Inputs.interest')}
        />
        <FormSelect
          selectFor="pvg"
          formik={formik}
          options={PVG_SELECT_OPTIONS}
          labelText={Copy.generate('Inputs.pvg')}
        />
        <FormInput
          inputFor="child"
          formik={formik}
          labelText={Copy.generate('Inputs.child')}
          required
        />
        <FormInput
          inputFor="class"
          formik={formik}
          labelText={Copy.generate('Inputs.class')}
          required
        />
        <Button
          type="submit"
          fullWidth={true}
          text={Copy.generate('Buttons.submit')}
          sx={{ ...buttonSx(theme), ...marginTop16Sx }}
        />
      </Form>
    </FormContainer>
  );
};
